import styled from 'styled-components'

export const FeatureTopicList = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 16px;
  gap: 16px;
`

export const FeatureTopic = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;

  span {
    flex: 1;
  }
`
